import { Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

// Model

export class CashAccountLiteModel extends CommonModel {
  code: string;
  name: string;
  description?: string | null;

  @Type(() => Number)
  balance: number;
}

export class CashAccountModel extends CashAccountLiteModel {}

// Input

export type getCashAccountsInput = {
  params: CommonParamInput;
};

export type getCashAccountInput = {
  id: string;
};

export type CashAccountMutationInput = {
  code: string;
  name: string;
  description?: string | null;
};

export type CashAccountUpdateInput = {
  cashAccountId: string;
  body: CashAccountMutationInput;
};

export type CashAccountDeleteInput = {
  cashAccountId: string;
};
